import { useEffect, useState } from 'react';
import FormFloating from '../../components/ui/form/FormFloating';
import { OrderService } from '../../core/services/order.service';
import { redirect, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../libs/hook';
import { hideSpinner, showSpinner } from '../../libs/features/spinnerSlice';
import { toast } from 'react-toastify';
import { ShipmentService } from '../../core/services/shipment.service';
import NumberFormat from '../../components/common/NumberFormat';
import FormFloatingNumber from '../../components/ui/form/FormFloatingNumber';

import Currency from '../../components/common/Currency';
import FormFloatingSelect from '../../components/ui/form/FormFloatingSelect';
import { UserService } from '../../core/services/user.service';
import InputSurcharge from '../../components/common/InputSurcharge';
import Swal from 'sweetalert2';

export default function ExportTracking() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const shipmentId = params.get('id');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [orderDetail, setOrderDetail] = useState<any>({});
  let [exportRequest, setExportRequest] = useState<any>({});
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [trackingExport, setTrackingExport] = useState<any>({});
  const [vehicleInfo, setVehicleInfo] = useState<any>({});
  const [sellers, setSellers] = useState<any[]>([]);
  const [isOrderExists, setIsOrderExists] = useState<boolean>(true);
  const [timeoutCustomerId, setTimeoutCustomerId] = useState<any>();
  const [timeoutPhoneNumber, setTimeoutPhoneNumber] = useState<any>();
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    getOrder();
    getSellers();
  }, [id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      getVehicleByLicensePlate(exportRequest.licensePlate);
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [exportRequest.licensePlate]);

  const getOrder = () => {
    dispatch(showSpinner());
    OrderService.getOrderById(id)
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        if (res.data.status) {
          setOrderDetail(res.data.responseData);
          convertData(res.data.responseData);
        } else {
          setIsOrderExists(false);
        }
      });
  };

  const trimProperties = (obj: any): any => {
    if (typeof obj !== 'object' || obj === null) {
      return obj; // Nếu không phải object, trả về chính nó
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[key] = typeof value === 'string' ? value.trim() : value;
      return acc;
    }, {} as any);
  };

  const convertData = (data: any) => {
    if (shipmentId) {
      let temp: any = data.shipments.find((item: any, idx: any) => item.id == shipmentId);
      temp.customerPhone = data.recipientPhoneNumber;
      temp.customerId = data.customerId;
      temp.sellerId = data.sellerId;
      setExportRequest({ ...temp });

      let trackingTemp = temp?.trackings[0];
      setTrackingExport({ ...trackingTemp });
    } else {
      exportRequest.customerPhone = data.recipientPhoneNumber;
      exportRequest.customerId = data.customerId;
      exportRequest.sellerId = data.sellerId;
      setExportRequest({ ...exportRequest });
    }
  };

  const onSubmitExport = () => {
    if (vehicleInfo.licensePlate && vehicleInfo.status != '09-01') {
      toast.error(`Xe ${vehicleInfo.licensePlate} đã thông quan nên không thể xuất`);
      return;
    }
    if (exportRequest.id) {
      handleEditExportShipment();
    } else {
      handleCreateExportShipment();
    }
  };

  const handleCreateExportShipment = () => {
    setSubmitted(true);
    if (validate()) {
      toast.error("Nhập thiếu thông tin bắt buộc");
      return;
    }

    exportRequest.orderId = orderDetail.orderId;
    exportRequest = trimProperties(exportRequest);
    ShipmentService.exportShipment(exportRequest)
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        if (res.data.status) {
          toast.success('Xuất kho thành công');
          navigate(`/order-mgt/detail/${id}`);
          return;
        }
        toast.error(<div>{res.data.message}</div>);
      });
  };

  const handleEditExportShipment = () => {
    setSubmitted(true);
    if (validate()) {
      toast.error("Nhập thiếu thông tin bắt buộc");
      return;
    }
    exportRequest.shipmentId = exportRequest.id;
    exportRequest.orderId = orderDetail.orderId;
    exportRequest.trackId = trackingExport.trackId;

    exportRequest = trimProperties(exportRequest);
    dispatch(showSpinner());
    ShipmentService.editExportShipment(exportRequest)
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        if (res.data.status) {
          toast.success('Cập nhật thành công');
          navigate(`/order-mgt/detail/${id}`);
          return;
        }
        toast.error('Đã có lỗi xảy ra trong quá trình xử lý, vui lòng thử lại');
      });
  };

  const validate = () => {
    if (!exportRequest.address || !exportRequest.borderGate || !exportRequest.vehicleType || !exportRequest.numberParcel || !exportRequest.licensePlate || !exportRequest.customerId || !exportRequest.sellerId || !exportRequest.customerPhone) {
      return true;
    }

    if (vehicleInfo.licensePlate && vehicleInfo.status != '09-01') {
      return true;
    }

    let totalNumberParcelExported = 0;
    if (exportRequest.id) {
      orderDetail.shipments?.forEach((element: any) => {
        if (element.id != exportRequest.id) {
          totalNumberParcelExported += element.numberParcel;
        }
      });
    } else {
      orderDetail.shipments?.forEach((element: any) => {
        totalNumberParcelExported += element.numberParcel;
      });
    }
    exportRequest.domesticFee = exportRequest.domesticFee ? exportRequest.domesticFee : 0;
    exportRequest.towingFee = exportRequest.towingFee ? exportRequest.towingFee : 0;
    exportRequest.forkliftFee = exportRequest.forkliftFee ? exportRequest.forkliftFee : 0;
    exportRequest.woodenFee = exportRequest.woodenFee ? exportRequest.woodenFee : 0;
    exportRequest.payOnHehalf = exportRequest.payOnHehalf ? exportRequest.payOnHehalf : 0;

    let errorsTemp: any = {};
    if (( Number(totalNumberParcelExported || 0) + Number(exportRequest.numberParcel || 0)) >= orderDetail.numberParcel) {
      if (orderDetail.domesticFee > 0 && exportRequest.domesticFee <= 0) {
        errorsTemp.domesticFee = 'Thiếu cước nội địa';
      }
      if (orderDetail.towingFee > 0 && exportRequest.towingFee <= 0) {
        errorsTemp.towingFee = 'Thiếu cước kéo xe';
      }
      if (orderDetail.forkliftFee > 0 && exportRequest.forkliftFee <= 0) {
        errorsTemp.forkliftFee = 'Thiếu cước xe nâng';
      }
      if (orderDetail.woodenFee > 0 && exportRequest.woodenFee <= 0) {
        errorsTemp.woodenFee = 'Thiếu cước đóng gỗ';
      }
      if (orderDetail.payOnHehalf > 0 && exportRequest.payOnHehalf <= 0) {
        errorsTemp.payOnHehalf = 'Thiếu cước thanh toán hộ';
      }
    }

    if (orderDetail.domesticFee <= 0 && exportRequest.domesticFee > 0) {
      errorsTemp.domesticFee = 'Không thể thêm cước nội địa khi nhập kho không có';
    }
    if (orderDetail.towingFee <= 0 && exportRequest.towingFee > 0) {
      errorsTemp.towingFee = 'Không thể thêm cước kéo xe khi nhập kho không có';
    }
    if (orderDetail.forkliftFee <= 0 && exportRequest.forkliftFee > 0) {
      errorsTemp.forkliftFee = 'Không thể thêm cước xe nâng khi nhập kho không có';
    }
    if (orderDetail.woodenFee <= 0 && exportRequest.woodenFee > 0) {
      errorsTemp.woodenFee = 'Không thể thêm cước đóng gỗ khi nhập kho không có';
    }
    if (orderDetail.payOnHehalf <= 0 && exportRequest.payOnHehalf > 0) {
      errorsTemp.payOnHehalf = 'Không thể thêm cước thanh toán hộ khi nhập kho không có';
    }

    setErrors({...errorsTemp})
    if (errorsTemp?.domesticFee || errorsTemp?.towingFee || errorsTemp?.forkliftFee || errorsTemp?.woodenFee || errorsTemp?.payOnHehalf) {
      return true;
    }
    return false;
  };

  const onChangeValue = (event: any) => {
    let valueTemp = event.target.value + '';

    if (event.target.name == 'licensePlate') {
      valueTemp = valueTemp.trimStart();
    }

    if (event.target.name == 'customerPhone') {
      if (valueTemp.length <= 10) {
        exportRequest[event.target.name] = valueTemp;
      }
    } else {
      exportRequest[event.target.name] = valueTemp;
    }

    if (event.target.name == 'customerPhone') {
      fillCustomerPhone(valueTemp);
    }
    if (event.target.name == 'customerId') {
      fillCustomerId(valueTemp);
    }
    const sum =
      Number(exportRequest.domesticFee || 0) + Number(exportRequest.towingFee || 0) + Number(exportRequest.forkliftFee || 0) + Number(exportRequest.shippingFee || 0) + Number(exportRequest.woodenFee || 0) + Number(exportRequest.payOnHehalf || 0);
    exportRequest.totalFee = sum;
    exportRequest.payAmount = sum;

    setExportRequest({ ...exportRequest });
  };

  const getVehicleByLicensePlate = (licensePlate: any) => {
    if (licensePlate) licensePlate = licensePlate.trim();
    ShipmentService.getVehicleByLicensePlate(licensePlate).then((res) => {
      if (res.data.status) {
        setVehicleInfo({ ...res.data.responseData });
        if (res.data.responseData?.licensePlate) {
          exportRequest.borderGate = res.data.responseData?.borderGate;
          exportRequest.address = res.data.responseData?.address;
          exportRequest.driverName = res.data.responseData?.driverName;
          exportRequest.driverPhoneNumber = res.data.responseData?.driverPhoneNumber;
          exportRequest.licensePlate = res.data.responseData?.licensePlate;
          exportRequest.vehicleType = res.data.responseData?.vehicleType;
          setExportRequest({ ...exportRequest });
        } else {
          exportRequest.borderGate = '';
          exportRequest.address = '';
          exportRequest.driverName = '';
          exportRequest.driverPhoneNumber = '';
          // exportRequest.licensePlate = '';
          exportRequest.vehicleType = '';
          setExportRequest({ ...exportRequest });
        }
      } else {
        exportRequest.borderGate = '';
        exportRequest.address = '';
        exportRequest.driverName = '';
        exportRequest.driverPhoneNumber = '';
        // exportRequest.licensePlate = '';
        exportRequest.vehicleType = '';
        setExportRequest({ ...exportRequest });
      }
    });
  };

  const getSellers = async () => {
    await UserService.getAllSeller().then((res) => {
      let data = res.data;
      // data.unshift({ fullName: '---', username: null });
      setSellers(data);
    });
  };

  const onChangeSeller = (event: any) => {
    if (event) {
      exportRequest.sellerId = event?.username;
    } else {
      exportRequest.sellerId = null;
    }
    setExportRequest({ ...exportRequest });
  };

  const fillCustomerPhone = (customerPhone: any) => {
    if (timeoutPhoneNumber) {
      clearTimeout(timeoutPhoneNumber);
    }
    const timeoutTemp = setTimeout(() => {
      UserService.getCustomerByPhoneNumber(customerPhone).then((res) => {
        if (res.data.status) {
          let userTemp = res.data.responseData;
          exportRequest.customerId = userTemp.username;
          setExportRequest({ ...exportRequest });
        } else {
          UserService.getCustomerByUserName(exportRequest.customerId).then((res) => {
            if (res.data.status) {
              exportRequest.customerId = '';
              setExportRequest({ ...exportRequest });
            }
          });
        }
      });
    }, 500);
    setTimeoutPhoneNumber(timeoutTemp);
  };

  const fillCustomerId = (customerId: any) => {
    if (timeoutCustomerId) {
      clearTimeout(timeoutCustomerId);
    }
    const timeoutTemp = setTimeout(() => {
      UserService.getCustomerByUserName(customerId).then((res) => {
        if (res.data.status) {
          let userTemp = res.data.responseData;
          exportRequest.customerPhone = userTemp.phoneNumber;
          setExportRequest({ ...exportRequest });
        } else {
          UserService.getCustomerByPhoneNumber(exportRequest.customerPhone).then((res) => {
            if (res.data.status) {
              exportRequest.customerPhone = '';
              setExportRequest({ ...exportRequest });
            }
          });
        }
      });
    }, 500);
    setTimeoutCustomerId(timeoutTemp);
  };

  const deleteShipment = (shipmentId :any) =>{
        Swal.fire({
          title: 'Bạn có chắc chắn muốn xóa?',
          text: 'Trạng thái của đơn hàng có thể bị thay đổi!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Xác nhận!',
          cancelButtonText: 'Hủy'
        }).then((result:any) => {
          if (result.isConfirmed) {
            dispatch(showSpinner());
                  ShipmentService.deleteShipment(shipmentId).then((res)=>{
                if (res.data.status) {
                  toast.success('Xóa chuyến xe thành công');
                  navigate(-1);
                } else {
                  toast.error('Đã có lỗi xảy ra trong quá trình xử lý, vui lòng thử lại');
                }
              });
          }
        });
  }

  return (
    <>
      {isOrderExists && (
        <div className="app-ecommerce">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
            <div className="d-flex flex-column justify-content-center">
              <h4 className="mb-1">{shipmentId ? 'Sửa đổi thông tin chuyến hàng' : 'Xuất kho'}</h4>
             </div>
            <div className="d-flex align-content-center flex-wrap gap-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(`/order-mgt/detail/${id}`)}>
                Hủy
              </button>
              {/* {
                shipmentId && <button type="button" className="btn btn-danger" onClick={()=>deleteShipment(shipmentId)}>
                  Xóa
                </button>
              } */}
              <button type="button" className="btn btn-primary" onClick={onSubmitExport}>
                Lưu
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="card mb-6">
                <div className="card-header">
                  <h5 className="card-tile mb-0">Thông tin nhập hàng</h5>
                </div>
                <div className="card-body">
                  <div className="row g-5">
                    <div className="col-12">
                      <div className="d-flex justify-content-between field-info">
                        <div>Mã đơn hàng</div>
                        <div>
                          {orderDetail.orderId}{' '}
                          <a
                            onClick={() => {
                              navigator.clipboard.writeText(orderDetail.orderId);
                              toast.success('Đã copy!');
                            }}
                            className="cursor-pointer"
                          >
                            <i className="ri-file-copy-2-line"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex justify-content-between field-info">
                        <div>Số kiện</div>
                        <div>{orderDetail.numberParcel}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex justify-content-between field-info">
                        <div>Loại hàng hóa</div>
                        <div>{orderDetail.productType}</div>
                      </div>
                    </div>
                    {orderDetail.weight > 0 && (
                      <div className="col-6">
                        <div className="d-flex justify-content-between field-info">
                          <div>Số cân</div>
                          <div>{orderDetail.weight ? <>{orderDetail.weight} kg</> : '-'}</div>
                        </div>
                      </div>
                    )}

                    {orderDetail.size > 0 && (
                      <div className="col-6">
                        <div className="d-flex justify-content-between field-info">
                          <div>Số khối</div>
                          <div>
                            {orderDetail.size ? (
                              <>
                                {orderDetail.size} m<sup>3</sup>
                              </>
                            ) : (
                              '-'
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {orderDetail.piece > 0 && (
                      <div className="col-6">
                        <div className="d-flex justify-content-between field-info">
                          <div>Số cái</div>
                          <div>{orderDetail.piece ? <NumberFormat value={orderDetail.piece}></NumberFormat> : '-'}</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="card mb-6">
                <div className="card-header d-flex justify-content-between align-item-center">
                  <h5 className="card-tile mb-0">Thông tin vận chuyển</h5>
                </div>
                <div className="card-body">
                  <div className="row g-5">
                    <div className="col-12">
                      <div className='mb-1' style={{fontSize: '14px', textTransform: 'none', fontStyle: 'italic', fontWeight: '400'}}> **Biển số xe kết thúc bằng ngày xuất kho dạng ddmmyy. Ví dụ ngày 18/10/2024: 29B 45678 181024</div>
                      <FormFloating
                        type="text"
                        label="Biến số xe"
                        placeholder="Biến số xe"
                        name="licensePlate"
                        onChange={onChangeValue}
                        value={exportRequest.licensePlate || ''}
                        isError={submitted && (!exportRequest.licensePlate || exportRequest.licensePlate?.trim().length <= 0) ? true : false}
                        errMsg="Biến số xe còn trống"
                        disabled={shipmentId ? true : false}
                        required
                      ></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating
                        type="number"
                        label="Số kiện"
                        placeholder="Số kiện"
                        name="numberParcel"
                        onChange={onChangeValue}
                        value={exportRequest.numberParcel || ''}
                        isError={submitted && !exportRequest.numberParcel ? true : false}
                        errMsg="Số kiện còn trống"
                        min="1"
                        required
                      ></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating type="number" label="Số cân" placeholder="Số cân" name="weight" onChange={onChangeValue} value={exportRequest.weight || ''} min="0"></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating type="number" label="Số khối" placeholder="Số khối" name="size" onChange={onChangeValue} value={exportRequest.size || ''} min="0"></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating type="number" label="Số cái" placeholder="Số cái" name="piece" onChange={onChangeValue} value={exportRequest.piece || ''} min="0"></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloatingNumber label="Giá theo cân" placeholder="Giá theo cân" name="feeByWeight" onChange={onChangeValue} defaultValue={exportRequest.feeByWeight || 0} min="0" mode="currency" locale="VND" />
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloatingNumber label="Giá theo khối" placeholder="Giá theo khối" name="feeBySize" onChange={onChangeValue} defaultValue={exportRequest.feeBySize || 0} min="0" mode="currency" locale="VND" />
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloatingNumber label="Giá theo cái" placeholder="Giá theo cái" name="feeByPiece" onChange={onChangeValue} defaultValue={exportRequest.feeByPiece || 0} min="0" mode="currency" locale="VND" />
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating
                        type="text"
                        label="Cửa khẩu"
                        placeholder="Cửa khẩu"
                        name="borderGate"
                        onChange={onChangeValue}
                        value={exportRequest.borderGate || ''}
                        min="0"
                        isError={submitted && !exportRequest.borderGate ? true : false}
                        errMsg="Cửa khẩu còn trống"
                        // disabled={vehicleInfo.borderGate ? true : false}
                        required
                      ></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating
                        type="text"
                        label="Loại xe"
                        placeholder="Loại xe"
                        name="vehicleType"
                        onChange={onChangeValue}
                        value={exportRequest.vehicleType || ''}
                        min="0"
                        isError={submitted && !exportRequest.vehicleType ? true : false}
                        errMsg="Loại xe còn trống"
                        // disabled={vehicleInfo.vehicleType ? true : false}
                        required
                      ></FormFloating>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <FormFloating
                        type="text"
                        label="Điểm đến"
                        placeholder="Điểm đến"
                        name="address"
                        maxLength={2}
                        minLength={2}
                        isError={submitted && (!exportRequest.address || exportRequest.address?.trim().length <= 0) ? true : false}
                        errMsg="Điểm đến còn trống"
                        onChange={onChangeValue}
                        value={exportRequest.address || ''}
                        // disabled={vehicleInfo.address ? true : false}
                        required
                      ></FormFloating>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="card mb-6">
                <div className="card-header d-flex justify-content-between align-item-center">
                  <h5 className="card-tile mb-0">Thông tin xuất kho</h5>
                </div>
                <div className="card-body">
                  <div className="row gx-5 gy-5">
                    <div className="col-6">
                      <FormFloating
                        type="number"
                        label="SĐT người nhận"
                        placeholder="SĐT người nhận"
                        isError={submitted && !exportRequest.customerPhone ? true : false}
                        errMsg={'Số điện thoại còn trống'}
                        onChange={onChangeValue}
                        name="customerPhone"
                        value={exportRequest.customerPhone || ''}
                        required
                      ></FormFloating>
                    </div>
                    <div className="col-6">
                      <FormFloating
                        type="text"
                        label="Mã khách hàng"
                        placeholder="Mã khách hàng"
                        isError={submitted && !exportRequest.customerId ? true : false}
                        errMsg="Mã khách hàng còn trống"
                        onChange={onChangeValue}
                        value={exportRequest.customerId || ''}
                        name="customerId"
                        required
                      ></FormFloating>
                    </div>

                    <div className="col-12">
                      <FormFloatingSelect
                        label="Nhân viên bán hàng"
                        sources={sellers}
                        bindLabel="username"
                        defaultValue={exportRequest.sellerId}
                        bindValue="username"
                        onChange={(event) => onChangeSeller(event)}
                        isError={submitted && !exportRequest.sellerId ? true : false}
                        errMsg="Nhân viên bán hàng còn trống"
                        required
                      ></FormFloatingSelect>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mb-6">
                <div className="card-header">
                  <h5 className="card-tile mb-0">Thông tin cước phí</h5>
                </div>
                <div className="card-body">
                  <div className="row g-5">
                    <div className="col-sm-12">
                      <FormFloatingNumber label="Cước vận chuyển" placeholder="Cước vận chuyển" name="shippingFee" onChange={onChangeValue} defaultValue={exportRequest.shippingFee || 0} min="0" mode="currency" locale="VND" />
                    </div>
                    <div className="col-12 border-bottom pb-6">
                      <div>Cước phụ</div>
                      <div className="ps-10 mt-6">
                        <div className="row g-5">
                          <div className="col-sm-12 col-lg-6">
                            <InputSurcharge
                              label="Cước nội địa (đ)"
                              placeholder="Cước nội địa"
                              name="domesticFee"
                              onChange={onChangeValue}
                              defaultValue={exportRequest.domesticFee || 0}
                              min="0"
                              rmbValue={orderDetail.domesticFee}
                              isError={submitted && errors?.domesticFee ? true : false}
                              errMsg={errors?.domesticFee}
                            ></InputSurcharge>
                          </div>
                          <div className="col-sm-12 col-lg-6">
                            <InputSurcharge
                              label="Kéo xe (đ)"
                              placeholder="Kéo xe"
                              name="towingFee"
                              onChange={onChangeValue}
                              defaultValue={exportRequest.towingFee || 0}
                              min="0"
                              rmbValue={orderDetail.towingFee}
                              isError={submitted && errors?.towingFee ? true : false}
                              errMsg={errors?.towingFee}
                            ></InputSurcharge>
                          </div>
                          <div className="col-sm-12 col-lg-6">
                            <InputSurcharge
                              label="Xe nâng (đ)"
                              placeholder="Xe nâng"
                              name="forkliftFee"
                              onChange={onChangeValue}
                              defaultValue={exportRequest.forkliftFee || 0}
                              min="0"
                              rmbValue={orderDetail.forkliftFee}
                              isError={submitted && errors?.forkliftFee ? true : false}
                              errMsg={errors?.forkliftFee}
                            ></InputSurcharge>
                          </div>
                          <div className="col-sm-12 col-lg-6">
                            <InputSurcharge
                              label="Đóng gỗ (đ)"
                              placeholder="Đóng gỗ"
                              name="woodenFee"
                              onChange={onChangeValue}
                              defaultValue={exportRequest.woodenFee || 0}
                              min="0"
                              rmbValue={orderDetail.woodenFee}
                              isError={submitted && errors?.woodenFee ? true : false}
                              errMsg={errors?.woodenFee}
                            ></InputSurcharge>
                          </div>
                          <div className="col-sm-12 col-lg-6">
                            <InputSurcharge
                              label="Thanh toán hộ (đ)"
                              placeholder="Thanh toán hộ"
                              name="payOnHehalf"
                              onChange={onChangeValue}
                              defaultValue={exportRequest.payOnHehalf || 0}
                              min="0"
                              rmbValue={orderDetail.payOnHehalf}
                              isError={submitted && errors?.payOnHehalf ? true : false}
                              errMsg={errors?.payOnHehalf}
                            ></InputSurcharge>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 d-flex justify-content-between">
                      <div className="fs-5 fw-semibold">Tổng tiền</div>
                      {exportRequest.totalFee ? (
                        <div className="text-danger fw-semibold">
                          {' '}
                          <Currency price={exportRequest.totalFee}></Currency>
                        </div>
                      ) : (
                        <div className="text-danger fw-semibold">--</div>
                      )}
                    </div>
                    <div className="col-12">
                      <FormFloatingNumber label="Số tiền cần thanh toán" placeholder="Số tiền cần thanh toán" name="payAmount" onChange={onChangeValue} defaultValue={exportRequest.payAmount || 0} min="0" mode="currency" locale="VND" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {!isOrderExists && (
        <div className="app-ecommerce">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
            <div className="d-flex flex-column justify-content-center">
              <h4 className="mb-1">Đơn hàng không tồn tại</h4>
            </div>
            <div className="d-flex align-content-center flex-wrap gap-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(`/order-mgt`)}>
                Quay lại
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
